import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  private handlers: { [key: string]: DetachedRouteHandle } = {};

  // Decide if we should detach a route (only detach home page)
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig?.path === '';
  }

  // Store the detached route
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    if (route.routeConfig?.path === '') {
      if (handle) {
        this.handlers['home'] = handle;
      } else {
        delete this.handlers['home'];
      }
    }
  }

  // Decide if we should attach a stored route
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return route.routeConfig?.path === '' && !!this.handlers['home'];
  }

  // Retrieve the stored route
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    if (route.routeConfig?.path === '') {
      return this.handlers['home'] || null;
    }
    return null;
  }

  // Determine if a route should be reused
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
